module.exports = ".file-div {\n\tborder: solid black 1px;\n\tborder-radius: 5px;\n\tpadding: 10px;\n\tmargin-top: 25px;\n}\n"